<template>
    <div v-if="show && newOptimize && newOptimize.image"
        :class="[$prefixClass.card + '-stroke box-upgrade']"
    >
        <i class="box-upgrade__close-box far fa-times" @click="closeBox"></i>
        <div class="box-upgrade__img">
            <img src="@/assets/images/tooltip-actual.svg" alt="actual">
        </div>
        <h4 class="box-upgrade__title">{{$t('dashboard.box_upgrade.title')}}</h4>
        <p v-html="$t('dashboard.box_upgrade.content', {size: formatSize(newOptimize.image.total_saved)})"></p>
        <a-button type="default" @click="$router.push({name: $routerName.PRICING})">{{$t('dashboard.box_upgrade.btn_text')}}</a-button>
    </div>
</template>
<script>
import { mapGetters } from 'vuex'
import { types as typesAuth } from "@/modules/auth/constant"
import { types as typesOptimize } from '@/modules/optimize_image/constant'
import cookie from 'js-cookie'
export default {
    name: 'BoxUpgrade',
    props: {
        value: {
            type: Boolean,
            required: true
        }
    },
    data() {
        return {
            show: false
        }
    },
    computed: {
        ...mapGetters({
            store: typesAuth.getters.GET_STORE,
            newOptimize: typesOptimize.getters.GET_NEW_OPTIMIZE
        }),
        isVisible: {
            get: function() {
                return this.value
            },
            set: function(newValue) {
                this.$emit('input', newValue)
            }
        }
    },
    watch: {
        isVisible: {
            handler( val ) {
                if ( val ) {
                    this.show = !this.store.plan_info.optimize_images && !this.store.plan_info.optimize_theme && !cookie.get('close-actual-banner')
                } else {
                    this.show = false
                }
            },
            deep: true
        }
    },
    created() {
        if ( this.isVisible ) {
            this.show = !this.store.plan_info.optimize_images && !this.store.plan_info.optimize_theme && !cookie.get('close-actual-banner')
        }
    },
    methods: {
        closeBox() {
            if ( cookie.get('close-actual-banner-first-time') ) {
                cookie.remove('close-actual-banner')
                cookie.remove('close-actual-banner-first-time')
                cookie.set('close-actual-banner', true, { expires: 30*6 })
            } else {
                cookie.set('close-actual-banner-first-time', true, { expires: 30 })
                cookie.set('close-actual-banner', true, { expires: 7 })
            }
            this.isVisible = false
        },
        handleAction() {
        }
    }
}
</script>
<style lang="scss">
    .box-upgrade {
        min-width: 358px;
        width: 358px;
        padding: 28px 32px 24px 32px;
        background-image: url(../assets/bg-box.svg);
        background-position: center;
        background-repeat: no-repeat;
        background-size: cover;
        border-radius: 8px;
        color: #FFFFFF;
        text-align: center;
        position: relative;
        
        &__title {
            padding-top: 10px;
        }
        &__close-box {
            position: absolute;
            top: 10px;
            right: 15px;
            cursor: pointer;
        }

        &__img {
            img {
                max-width: 210px;
            }
        }
    }
</style>